export const batchSelector = ({ batch }) => batch;
